<div style="text-align:center" [ngClass]="isMobile ? 'footer-confirm-mob' : 'footer-confirm'">
  <div class="button-container button-container-mob">
    <button type="button" class = "modify-button" (click)="actionCancel()">
      {{'POLL-WARNING.CANCEL' | translate}}
    </button>
    <button type="button" id="button-vote" class="button-blue" (click)="actionVoted()">
      {{'POLL-CHOICE.ACTION_VOTE' | translate}}
    </button>
  </div>
</div>
